import React from "react";
import NavPanel from "../Common/Nav/NavPanel.jsx";
import NavItemGame from "../Common/Nav/NavItem/NavItemGame.jsx";

const GamesLinksPanel = ({ name, games, updated, children }) => {
  return (
    <NavPanel
      name={name}
      items={games}
      renderItem={makeFunctionToRenderGameMenuItem(updated)}
      showPerPage={20}
    >
      {children}
    </NavPanel>
  );
};

const makeFunctionToRenderGameMenuItem = updated =>
  // eslint-disable-next-line react/display-name
  game => (
    <NavItemGame
      key={game.id}
      markNewResults={updated.includes(game.id)}
      title={game.name}
      id={game.id}
      sport={game.sport}
      game={game}
    />
  );

export default GamesLinksPanel;
